exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dayLabel__2n655 {\n  padding: 4px 16px;\n  font-weight: 400;\n  vertical-align: top;\n  color: #666;\n  background: #eee;\n  font-size: 12px;\n  margin: 0;\n  border-radius: 4px;\n}\n", ""]);

// Exports
exports.locals = {
	"dayLabel": "dayLabel__2n655"
};